export const REQUEST_STATUS = {
  FINISHED: "@request/finished",
  FAILED: "@request/failed",
} as const;
